module.exports = __webpack_public_path__ + "img/rule3.b36b4178.png";